<ng-container class="open-banking">
   <app-apg-open-banking-affordability></app-apg-open-banking-affordability>
    <!-- <app-apg-open-banking-payment></app-apg-open-banking-payment>  -->
</ng-container>